<template>
  <div id="pageRoot" class="blind">
    <p class="pageElement title" style="left: 30px; position: absolute; top: -20px; ">
      LAS TRES PRUEBAS
    </p>

    <span class="pageInstruction" style="left: 30px; top: 100px;">
      <p >Escribe los nombres de los animales.</p>
    </span>
    <span class="pageInstruction" style="left: 30px; top: 140px;">
      <p>Usando las flechas busca el elemento que<br>usó en la prueba.</p>
    </span>

    <img
      id="bees"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasBees.svg"
    />
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01Disabled"
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="slider01"
      ref="imageSlider1"
      style="width: 200px; height: 170px;  right: 60px; margin-top: 205px"
    />

    <img
      id="ducks"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasDucks.svg"
    />
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="slider02"
      ref="imageSlider2"
      style="width: 200px; height: 170px; right: 60px; margin-top: 395px"
    />

    <img
      id="ants"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCasAnts.svg"
    />
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <image-option-slider
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="slider03"
      ref="imageSlider3"
      style="width: 200px; height: 170px;  right: 60px; margin-top: 590px"
    />
  </div>
</template>

<style scoped>
#bg {
  position: absolute;
  left: 80px;
  top: 42px;
  z-index: -1;
}
#inputField01Disabled {
  position: absolute;
  width: 400px;
  left: 300px;
  top: 270px;
}
#inputField01 {
  position: absolute;
  width: 400px;
  left: 300px;
  top: 455px;
}
#inputField02 {
  position: absolute;
  width: 400px;
  left: 300px;
  top: 655px;
}
#bees {
  position: absolute;
  left: 18px;
  top: 230px;
}
#ducks {
  position: absolute;
  left: 5px;
  top: 427px;
}
#ants {
  position: absolute;
  left: 30px;
  top: 608px;
}
</style>

<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 25.mp4",
      ],
      options: [
        "sordocas/assets_p13/key.svg",
        "sordocas/assets_p13/princesses.svg",
        "sordocas/assets_p13/pearl.svg",
      ],
    };
  },
  mounted() {
    this.$refs.imageSlider1.loadOptions(this.options);
    this.$refs.imageSlider2.loadOptions(this.options);
    this.$refs.imageSlider3.loadOptions(this.options);
  },
};
</script>